/**
 * The four Schülerhilfe brand domains. The string values match the `domain:`
 * Tag values used across the CMS and backend (e.g. `domain:de`) and the
 * `domainTag` of each Cloudflare zone.
 */
export enum Domain {
  De = 'de',
  At = 'at',
  Ch = 'ch',
  Erna = 'erna',
}

const DOMAIN_VALUES: ReadonlySet<string> = new Set(Object.values(Domain));

/** Type guard: is `value` one of the known {@link Domain} values? */
export function isDomain(value: string): value is Domain {
  return DOMAIN_VALUES.has(value);
}
